import { useState } from "react";

type FormResponse = {
  code?: string;
  message?: string;
  meta?: { message?: string; detail?: string };
};

const SUBMIT_ADDR = "https://readdy.ai/api/form/dahbm0rp14a1h3mr6ht0";

export default function NewsletterForm() {
  const [status, setStatus] = useState<"idle" | "loading" | "success" | "error">("idle");
  const [message, setMessage] = useState("");

  const handleSubmit = async (event: React.FormEvent<HTMLFormElement>) => {
    event.preventDefault();
    const form = event.currentTarget;
    const formData = new FormData(form);

    const honeypot = String(formData.get("website_alt") ?? "").trim();
    if (honeypot) {
      setStatus("success");
      setMessage("订阅成功，瓜报会准时送到你的邮箱。");
      return;
    }

    const payload = new URLSearchParams();
    formData.forEach((value, key) => {
      if (key === "website_alt") {
        return;
      }
      const text = String(value);
      if (text.trim() === "") {
        return;
      }
      payload.append(key, text);
    });

    setStatus("loading");
    setMessage("");

    try {
      const response = await fetch(SUBMIT_ADDR, {
        method: "POST",
        headers: { "Content-Type": "application/x-www-form-urlencoded" },
        body: payload.toString(),
      });
      const responseText = await response.text();
      let parsed: FormResponse | null = null;
      try {
        parsed = JSON.parse(responseText) as FormResponse;
      } catch {
        parsed = null;
      }
      const serverMsg =
        parsed?.meta?.message ||
        parsed?.message ||
        parsed?.meta?.detail ||
        responseText ||
        "";
      const isSpam = /spam/i.test(String(serverMsg));

      if (response.ok && parsed?.code === "OK" && !isSpam) {
        setStatus("success");
        setMessage("订阅成功，瓜报会准时送到你的邮箱。");
        form.reset();
      } else {
        setStatus("error");
        setMessage(serverMsg || "提交失败，请稍后再试。");
      }
    } catch (error) {
      setStatus("error");
      setMessage("网络异常，请稍后再试。");
    }
  };

  return (
    <form
      id="guabao-subscribe-form"
      data-readdy-form
      onSubmit={handleSubmit}
      className="w-full"
      noValidate
    >
      <label htmlFor="guabao-email" className="sr-only">
        邮箱地址
      </label>
      <div className="flex flex-col sm:flex-row gap-2">
        <input
          id="guabao-email"
          type="email"
          name="email"
          required
          autoComplete="email"
          placeholder="留下邮箱，订阅每日瓜报"
          className="flex-1 px-3.5 py-2.5 text-sm font-label rounded-md bg-secondary-900 border border-secondary-700 text-background-100 placeholder:text-background-400 focus:outline-none focus:border-accent-400 transition-colors"
        />
        <button
          type="submit"
          disabled={status === "loading"}
          className="inline-flex items-center justify-center gap-1.5 px-4 py-2.5 text-sm font-label font-medium rounded-md bg-accent-500 text-foreground-950 hover:bg-accent-400 transition-colors whitespace-nowrap disabled:opacity-60 cursor-pointer"
        >
          <i className={status === "loading" ? "ri-loader-4-line animate-spin" : "ri-send-plane-line"}></i>
          {status === "loading" ? "提交中" : "订阅瓜报"}
        </button>
      </div>

      <input
        type="text"
        name="website_alt"
        tabIndex={-1}
        autoComplete="off"
        aria-hidden="true"
        readOnly
        className="field-honeypot"
      />

      {status === "success" && (
        <p className="mt-2 text-xs font-label text-accent-300 flex items-center gap-1.5">
          <i className="ri-checkbox-circle-line"></i>
          {message}
        </p>
      )}
      {status === "error" && (
        <p className="mt-2 text-xs font-label text-primary-300 flex items-center gap-1.5">
          <i className="ri-error-warning-line"></i>
          {message}
        </p>
      )}
    </form>
  );
}